import { Login } from '@myosh/myosh-login'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import Meta from '../features/meta/meta'

export default function LoginPage() {
  const { search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const username = searchParams.get('userName') || searchParams.get('username') || undefined

  return (
    <>
      <Meta title='Training Management - login' />
      <Login redirectPath='/' username={username} />
    </>
  )
}
